import { render, staticRenderFns } from "./ProfileUniqueConfig.vue?vue&type=template&id=0f0c1db2&"
import script from "./ProfileUniqueConfig.vue?vue&type=script&lang=js&"
export * from "./ProfileUniqueConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports